import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IMailSchedule } from '../dto/MailSchedule';
import { supervisingModule } from '../../../store/modules/OperationSupervising';
import { KanriConstants } from '@/Kanri/fixed/KanriConstants';

/**
 * 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add
 */
@Module({ dynamic: true, store, name: 'mailSchedule', namespaced: true })
class MailSchedule extends VuexModule implements IMailSchedule {
    // state
    /**
     * @state
     * ID（キー）
     */
    scheduleId: string = '';

    /**
     * @state
     * データ複写状態
     */
    dataCopy: boolean = false;

    /**
     * @state
     * フォームデータ
     * 検索条件を格納する
     */
    formCondition: any = [];

    // getter
    /**
     * @Getter
     * パスの取得
     */
    get GET_PATH() {
        return `/${this.scheduleId}`;
    }

    /**
     * @Getter
     * 登録処理用パスの取得
     */
    get GET_REGIST_PATH() {
        if (this.GET_IS_ID_SETTING) {
            if (this.GET_DATA_COPY) {
                // 複写新規
                return KanriConstants.MAIL_SCHEDULE_PATH + '/create/copy' + this.GET_PATH;
            } else {
                // 更新
                return KanriConstants.MAIL_SCHEDULE_PATH + '/update' + this.GET_PATH;
            }
        } else {
            // 新規
            return KanriConstants.MAIL_SCHEDULE_PATH + '/create';
        }
    }

    /**
     * @Getter
     * 排他パスの取得
     */
    get GET_EXCLUSIVE_PATH() {
        return `/exclusive` + this.GET_PATH;
    }

    /**
     * @Getter
     * 排他パスの取得
     */
    get GET_EXCLUSIVE_DELETE_PATH() {
        return `/exclusive/delete` + this.GET_PATH;
    }

    /**
     * @Getter
     * データ複写状態の取得
     */
    get GET_DATA_COPY() {
        return this.dataCopy;
    }

    /**
     * @Getter
     * formDataの取得
     */
    get GET_FORM_CONDITION() {
        return this.formCondition;
    }

    /**
     * @Getter
     * formDataの設定の有無
     */
    get GET_IS_FORM_CONDITION_SETTING() {
        if (this.formCondition.length === 0) {
            return false;
        } else {
            return true;
        }
    }
    /**
     * @Getter
     * keyの設定の有無
     */
    get GET_IS_ID_SETTING() {
        if (this.scheduleId === '') {
            return false;
        } else {
            return true;
        }
    }
    // action
    /**
     * @Action
     * ID（キー）の保管
     * @param param (string)
     */
    @Action({})
    public setScheduleId(param: string) {
        this.SET_ID(param);
    }

    /**
     * @Action
     * データ複写状態の保管
     * @param param
     */
    @Action({})
    public setDataCopy(param: boolean) {
        this.SET_DATA_COPY(param);
    }

    /**
     * @Action
     * フォームデータの保管
     * @param data
     */
    @Action({})
    public setFormCondition(data: any) {
        this.SET_FORM_CONDITION(data);
    }

    /**
     * @Action
     * モジュールリセット
     */
    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
    }

    /**
     * @Action
     * モジュール選択情報リセット
     */
    @Action({})
    public moduleSelectReset() {
        this.MODULE_ID_RESET();
    }

    // mutation
    /**
     * @Mutation
     * ID（キー）の保管
     * @param param (string)
     */
    @Mutation
    private SET_ID(param: string) {
        this.scheduleId = param;
    }

    /**
     * @Mutation
     * データ複写状態の保管
     * @param param
     */
    @Mutation
    private SET_DATA_COPY(param: boolean) {
        this.dataCopy = param;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_FORM_CONDITION(data: any) {
        this.formCondition = data;
    }

    /**
     * @Mutation
     */
    @Mutation
    private MODULE_RESET() {
        this.scheduleId = '';
        this.formCondition = [];
    }

    /**
     * @Mutation
     */
    @Mutation
    private MODULE_ID_RESET() {
        this.scheduleId = '';
        this.dataCopy = false;
    }

}

export const mailSchedule = getModule(MailSchedule);
